import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { EmailTemplate } from '../../shared/models';
import { deserialize } from '../../shared/models/base-helper';
import * as fromApp from '../../store';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  apiUrl = environment.apiUrl;
  emailUrl = `${this.apiUrl}/emails`;

  constructor(readonly http: HttpClient, readonly store: Store<fromApp.AppState>) {}

  sendEmail(formData: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${this.emailUrl}/send/`, formData).pipe(map((result: any) => result['sent']));
  }

  getAllEmailTemplates(): Observable<EmailTemplate[]> {
    return this.http.get<EmailTemplate[]>(`${this.emailUrl}/templates/`);
  }

  getEmailTemplate(id: number): Observable<EmailTemplate> {
    return this.http
      .get<EmailTemplate>(`${this.emailUrl}/templates/${id}/`)
      .pipe(map((emailTemplate: any) => deserialize(emailTemplate, EmailTemplate)));
  }

  createEmailTemplate(body: any): Observable<EmailTemplate> {
    return this.http.post<EmailTemplate>(`${this.emailUrl}/templates/`, body);
  }

  updateEmailTemplate(id: number, body: any): Observable<EmailTemplate> {
    return this.http.patch<EmailTemplate>(`${this.emailUrl}/templates/${id}/`, body);
  }
}
